import DateField from '../components/DateField.vue';
// import TextEditor from '../components/text-editor/TextEditor.vue';
import FileUploader from '../components/FileUploader.vue';
import MaterialsViewer from '../components/MaterialsViewer.vue';
import PDFEditor from '../components/pdf-editor/PDFEditor.vue';
import TabTimer from '../components/TabTimer.vue';
import BtnTimer from '../components/BtnTimer.vue';
const Plugin = {}

Plugin.install = function install (Vue) {
    if (install.installed) return;
    install.installed = true;
    Vue.component('DateField', DateField);
    Vue.component('FileUploader', FileUploader);
    Vue.component('MaterialsViewer', MaterialsViewer);
    // Vue.component('TextEditor', TextEditor);
    Vue.component('PDFEditor', PDFEditor);
    Vue.component('TabTimer', TabTimer);
    Vue.component('BtnTimer', BtnTimer);
}

export default Plugin

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin)
}
